import { Flex, ScrollArea, Stack, Switch } from '@mantine/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SmallSquareButton } from '../../../../../components/small-square-button/small-square-button';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setRelatedTasksMode,
  setRelatedTasksUseGroups,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { secondaryBase } from '../../../../../styles/design-tokens';
import { Divider } from '../../../../../ui-library/divider/divider';
import { Select } from '../../../../../ui-library/select/select';
import { useCurrentStrategyTab } from '../../../strategy.hooks';
import { StrategyTab } from '../../../strategy.type';
import { RelatedTasksMode } from '../related-tasks-tab.type';
import { FiltersList } from './filters-list';
import { getRelatedTasksModeOptions } from './filters.helpers';

export const Filters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const i18n = useTranslation();
  const mode = useRelatedTasksTabStore((state) => state.mode);
  const useGroups = useRelatedTasksTabStore((state) => state.useGroups);
  const currentStrategyTab = useCurrentStrategyTab();

  const relatedTasksModeOptions = getRelatedTasksModeOptions(currentStrategyTab, i18n.t);

  const handleModeChange = (value: string) => {
    setRelatedTasksMode(value as RelatedTasksMode);
  };

  const handleUseGroupsChange = () => {
    setRelatedTasksUseGroups(!useGroups);
  };

  useEffect(() => {
    const validOptionValues = relatedTasksModeOptions.map((option) => option.value);
    if (!validOptionValues.includes(mode) && relatedTasksModeOptions.length > 0) {
      setRelatedTasksMode(relatedTasksModeOptions[0].value as RelatedTasksMode);
    }
  }, [mode, relatedTasksModeOptions]);

  return (
    <Stack gap="md" h="100%">
      <Flex justify="space-between" align="center" w="100%">
        <Select size="sm" options={relatedTasksModeOptions} value={mode} onChange={handleModeChange} />
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" style={{ flexShrink: 0 }} />
      </Flex>
      {currentStrategyTab !== StrategyTab.Epics && (
        <Switch
          label={i18n.t('common.use_groups')}
          color={secondaryBase}
          size="xs"
          checked={useGroups}
          onChange={handleUseGroupsChange}
        />
      )}
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <FiltersList />
      </ScrollArea>
    </Stack>
  );
};
